import React from 'react';

interface AnswerQualityHintProps {
  length: number;
}

interface HintLevel {
  minLength: number;
  message: string;
  colorClass: string;
  barWidth: string;
}

const HINT_LEVELS: HintLevel[] = [
  {
    minLength: 300,
    message: 'Uitstekend! Dit geeft ons genoeg om echt goede blogs voor je te schrijven.',
    colorClass: 'text-green-700',
    barWidth: 'w-full',
  },
  {
    minLength: 151,
    message: 'Heel goed! Een concreet voorbeeld maakt je profiel nog sterker.',
    colorClass: 'text-green-600',
    barWidth: 'w-3/4',
  },
  {
    minLength: 51,
    message: 'Mooi begin! Probeer ook te omschrijven hoe jij het anders doet dan anderen.',
    colorClass: 'text-amber-600',
    barWidth: 'w-2/4',
  },
  {
    minLength: 1,
    message: 'Goed begin! Hoe meer detail je geeft, hoe beter de blogs aansluiten op jouw bedrijf.',
    colorClass: 'text-amber-500',
    barWidth: 'w-1/4',
  },
];

const BAR_BG: Record<string, string> = {
  'w-full': 'bg-green-500',
  'w-3/4': 'bg-green-400',
  'w-2/4': 'bg-amber-400',
  'w-1/4': 'bg-amber-300',
};

export function AnswerQualityHint({ length }: AnswerQualityHintProps) {
  if (length === 0) return null;

  const level = HINT_LEVELS.find((l) => length >= l.minLength) ?? HINT_LEVELS[HINT_LEVELS.length - 1];

  return (
    <div className="mt-2 space-y-1.5">
      <div className="w-full h-1 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${level.barWidth} ${BAR_BG[level.barWidth]}`}
        />
      </div>
      <p className={`text-xs font-medium transition-all duration-300 ${level.colorClass}`}>
        {level.message}
      </p>
    </div>
  );
}
